import React, { Component } from "react";
import { Link } from "react-router-dom";

class ClaimCreateCreditCard extends Component {
  render() {
    return (
      <div style={{ padding: 24 }}>
        <div style={{ marginBottom: 22 }}>
          <h4 style={{ margin: 0, fontWeight: 900, color: "#0F172A" }}>
            Create Credit Card Claim
          </h4>
          <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
            Submit corporate credit card expenses with supporting receipts.
          </p>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 320px", gap: 22 }}>
          <div>
            <div style={card}>
              <h5 style={sectionTitle}>Card & Claim Information</h5>

              <div style={grid4}>
                {this.renderInput("Employee Name *", "Nurul Izzati Binti Rahman")}
                {this.renderInput("Employee ID", "EMP-2024-0062", true)}
                {this.renderInput("Department *", "Human Resources")}
                {this.renderInput("Cardholder Name *", "Nurul Izzati Binti Rahman")}
                {this.renderInput("Card Last 4 Digits *", "7821")}
                {this.renderInput("Statement Month *", "May 2024")}
                {this.renderInput("Claim Reference *", "CC-2024-0056")}
                {this.renderInput("Submission Date", "20 May 2024")}
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Credit Card Transactions</h5>

              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr style={{ background: "#F8FAFC" }}>
                    {[
                      "#",
                      "Transaction Date",
                      "Merchant",
                      "Description",
                      "Account Code",
                      "Amount (RM)",
                      "Receipt",
                      "Action",
                    ].map((h) => (
                      <th key={h} style={thStyle}>{h}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {[
                    ["1", "04 May 2024", "Agoda", "Hotel booking for HR workshop", "Accommodation", "1,280.00", "Uploaded"],
                    ["2", "07 May 2024", "Malaysia Airlines", "Flight ticket for official meeting", "Travel", "1,050.45", "Uploaded"],
                    ["3", "10 May 2024", "Zoom", "Online webinar subscription", "Training", "560.00", "Missing"],
                    ["4", "Select date", "Merchant name", "Enter transaction description", "Select account code", "0.00", "Upload"],
                  ].map((row) => (
                    <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                      <td style={tdStyle}>{row[0]}</td>
                      <td style={tdStyle}><input value={row[1]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[2]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[3]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[4]} readOnly style={tableInput} /></td>
                      <td style={tdStyle}><input value={row[5]} readOnly style={{ ...tableInput, textAlign: "right" }} /></td>
                      <td style={tdStyle}>{this.renderReceiptStatus(row[6])}</td>
                      <td style={tdStyle}><button style={deleteButton}>🗑</button></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button style={{ ...secondaryButton, marginTop: 14 }}>+ Add Transaction</button>

              <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 14, marginTop: 18 }}>
                <div style={{ fontWeight: 900 }}>TOTAL CREDIT CARD CLAIM (RM)</div>
                <div style={totalBox}>2,890.45</div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Supporting Receipts</h5>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18 }}>
                <div style={uploadBox}>
                  <div style={{ fontSize: 30 }}>☁</div>
                  <div style={{ marginTop: 8, color: "#64748B" }}>
                    Drag and drop receipts here, or <b>click to browse</b>
                  </div>
                  <div style={{ fontSize: 12, color: "#94A3B8", marginTop: 6 }}>
                    PDF, JPG, PNG up to 10MB each
                  </div>
                </div>

                <div>
                  <div style={{ fontWeight: 900, marginBottom: 10 }}>Uploaded Receipts (2)</div>
                  {["Agoda_Hotel_040524.pdf", "MAS_Flight_070524.pdf"].map((file) => (
                    <div key={file} style={fileRow}>
                      <span>{file}</span>
                      <span style={{ color: "#94A3B8" }}>×</span>
                    </div>
                  ))}

                  <div style={{ marginTop: 12, padding: 12, borderRadius: 8, background: "#FFF7E6", color: "#B76E00", fontSize: 13, fontWeight: 800 }}>
                    1 transaction is missing receipt.
                  </div>
                </div>
              </div>
            </div>

            <div style={card}>
              <h5 style={sectionTitle}>Declaration</h5>

              <label style={{ display: "flex", gap: 10, fontSize: 13, color: "#334155" }}>
                <input type="checkbox" defaultChecked />
                I confirm that all corporate credit card expenses listed above were incurred for official business purposes.
              </label>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 18, marginTop: 18 }}>
                {this.renderInput("Signature of Cardholder", "Nurul Izzati Binti Rahman")}
                {this.renderInput("Date", "20 May 2024")}
              </div>
            </div>

            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 18 }}>
              <Link to="/claim/create" style={secondaryLink}>Back</Link>
              <div style={{ display: "flex", gap: 10 }}>
                <button style={secondaryButton}>Save Draft</button>
                <button style={primaryButton}>Submit Claim ›</button>
              </div>
            </div>
          </div>

          <div>
            <div style={sideCard}>
              <h5 style={sectionTitle}>Claim Summary</h5>
              {this.renderSideRow("Transactions", "3")}
              {this.renderSideRow("Uploaded Receipts", "2 / 3")}
              {this.renderSideRow("Total Amount", "RM 2,890.45")}
              {this.renderSideRow("Statement Month", "May 2024")}
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Receipt Check</h5>
              <div style={checkRow}>✓ Hotel booking receipt uploaded</div>
              <div style={checkRow}>✓ Flight ticket receipt uploaded</div>
              <div style={warningRow}>! Webinar subscription receipt missing</div>
            </div>

            <div style={sideCard}>
              <h5 style={sectionTitle}>Policy Notes</h5>
              <ul style={sideText}>
                <li>All corporate card transactions must be supported by receipts.</li>
                <li>Personal expenses must not be claimed.</li>
                <li>Missing receipts may delay finance review.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderReceiptStatus(status) {
    const isUploaded = status === "Uploaded";

    return (
      <span
        style={{
          background: isUploaded ? "#ECFDF3" : "#FFF7E6",
          color: isUploaded ? "#027A48" : "#B76E00",
          padding: "5px 10px",
          borderRadius: 20,
          fontSize: 12,
          fontWeight: 900,
        }}
      >
        {status}
      </span>
    );
  }

  renderInput(label, value, disabled = false) {
    return (
      <div>
        <label style={labelStyle}>{label}</label>
        <input value={value} readOnly disabled={disabled} style={inputStyle} />
      </div>
    );
  }

  renderSideRow(label, value) {
    return (
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: "#64748B", fontSize: 13 }}>{label}</span>
        <b style={{ color: "#0F172A", fontSize: 13 }}>{value}</b>
      </div>
    );
  }
}

const card = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 18,
  marginBottom: 16,
};

const sideCard = {
  ...card,
  marginBottom: 16,
};

const sectionTitle = {
  margin: "0 0 16px",
  fontWeight: 900,
  color: "#0F172A",
};

const grid4 = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gap: 16,
};

const labelStyle = {
  display: "block",
  fontSize: 12,
  fontWeight: 800,
  color: "#334155",
  marginBottom: 8,
};

const inputStyle = {
  width: "100%",
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const thStyle = {
  padding: "10px 12px",
  textAlign: "left",
  fontWeight: 900,
  fontSize: 12,
  color: "#334155",
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: 8,
  fontSize: 13,
  color: "#334155",
};

const tableInput = {
  width: "100%",
  height: 34,
  border: "1px solid #E5E7EB",
  borderRadius: 6,
  padding: "0 10px",
  fontSize: 12,
  background: "#fff",
};

const totalBox = {
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 16px",
  minWidth: 170,
  textAlign: "right",
  fontWeight: 900,
  fontSize: 18,
};

const uploadBox = {
  border: "1px dashed #CBD5E1",
  borderRadius: 12,
  padding: 28,
  textAlign: "center",
  color: "#334155",
};

const fileRow = {
  border: "1px solid #E5E7EB",
  borderRadius: 8,
  padding: "10px 12px",
  marginBottom: 8,
  display: "flex",
  justifyContent: "space-between",
  fontSize: 13,
};

const deleteButton = {
  border: "1px solid #FECACA",
  color: "#DC111C",
  background: "#fff",
  borderRadius: 6,
  width: 32,
  height: 32,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  border: 0,
  borderRadius: 8,
  padding: "11px 22px",
  fontWeight: 900,
};

const secondaryButton = {
  background: "#fff",
  color: "#334155",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "10px 18px",
  fontWeight: 800,
};

const secondaryLink = {
  ...secondaryButton,
  textDecoration: "none",
};

const sideText = {
  color: "#64748B",
  fontSize: 13,
  lineHeight: "22px",
  paddingLeft: 18,
};

const checkRow = {
  color: "#027A48",
  fontSize: 13,
  fontWeight: 800,
  marginBottom: 10,
};

const warningRow = {
  color: "#B76E00",
  fontSize: 13,
  fontWeight: 800,
};

export default ClaimCreateCreditCard;